(function () {
    /* ----- constants ----- */
    const DRAG_START_THRESHOLD = 2;   // px
    const SLIDE_CHANGE_THRESHOLD = 2; // px (tap-like nudge)
    const ELASTIC = 0.35;             // resistance factor beyond bounds

    /* ----- initialise one slider ----- */
    function initProductSlider(sectionEl) {
        /* elements */
        const productSliderEl = sectionEl.querySelector('.product-slider-main') || sectionEl;
        const slider = sectionEl.querySelector('.slider-wrapper');
        const slides = Array.from(sectionEl.querySelectorAll('.slide'));
        if (!slides.length) return;

        const prevBtn = sectionEl.querySelector('.slider-arrow--prev');
        const nextBtn = sectionEl.querySelector('.slider-arrow--next');
        const dotContainer = sectionEl.querySelector('.slider-dots');
        let dots = [];

        /* data-attrs */
        const int = (attr, def) => parseInt(sectionEl.getAttribute(attr)) || def;
        const slidesDesktop     = int('data-slides-to-show',              4);
        const slidesMobile      = int('data-slides-to-show-mobile',       4);
        const slidesMobileSmall = int('data-slides-to-show-mobile-small', 4);

        const transitionMs = int('data-transition-speed', 400);
        const autoRotate   = sectionEl.getAttribute('data-auto-rotate') === 'true';
        const rotateMs     = int('data-rotate-speed', 3) * 400;

        const PEEK_FRACTION = 0.4;

        /* responsive slidesToShow */
        let cssVar, slidesToShow, isDesktop;
        if (innerWidth < 500) {
            cssVar = '--slides-to-show-mobile-small';
            slidesToShow = slidesMobileSmall;
            isDesktop = false;
        } else if (innerWidth < 768) {
            cssVar = '--slides-to-show-mobile';
            slidesToShow = slidesMobile;
            isDesktop = false;
        } else {
            cssVar = '--slides-to-show';
            slidesToShow = slidesDesktop;
            isDesktop = true;
        }

        /* peek-next logic */
        const peekBase    = sectionEl.getAttribute('data-peek-next') === 'true';
        const peekDesktop = sectionEl.getAttribute('data-peek-next-desktop') === 'true';
        const peekNext    = peekBase && slides.length > slidesToShow && (!isDesktop || peekDesktop);

        const visibleSlides = slidesToShow + (peekNext ? PEEK_FRACTION : 0);
        productSliderEl.style.setProperty(cssVar, visibleSlides);

        /* style basics */
        const defaultTransition = `transform ${transitionMs}ms ease-in-out`;
        slider.style.transition = defaultTransition;
        sectionEl.querySelectorAll('img,a').forEach(el => (el.draggable = false));
        ['userSelect','webkitUserSelect','MozUserSelect','msUserSelect'].forEach(p => (slider.style[p] = 'none'));

        /* geometry */
        const stepWidth = () => {
            const s = slides[0];
            return s.offsetWidth + (parseInt(getComputedStyle(s).marginRight) || 0);
        };
        const maxIndex = Math.max(0, slides.length - slidesToShow);
        const posFor = i => {
            const offset = peekNext && i === maxIndex ? stepWidth() * PEEK_FRACTION : 0;
            return -(i * stepWidth() - offset);
        };

        /* state */
        let index = 0;
        let autoId = null;

        const clamp = i => Math.max(0, Math.min(i, maxIndex));

        const setDot = () => dots.forEach((d, n) => {
            d.classList.toggle('slider-dot--active', n === index);
            d.toggleAttribute && d.toggleAttribute('aria-current', n === index);
        });

        // Important: do NOT disable the buttons; use aria-disabled for styling/AT only
        function updateControls() {
            const atStart = index === 0;
            const atEnd = index === maxIndex;
            if (prevBtn) {
                prevBtn.setAttribute('aria-disabled', String(atStart));
                prevBtn.classList.toggle('is-disabled', atStart);
            }
            if (nextBtn) {
                nextBtn.setAttribute('aria-disabled', String(atEnd));
                nextBtn.classList.toggle('is-disabled', atEnd);
            }
        }

        const goTo = i => {
            index = clamp(i);
            slider.style.transform = `translateX(${posFor(index)}px)`;
            setDot();
            updateControls();
        };

        // Wobble hint only for arrow clicks
        function wobbleEnd(direction) {
            const wobblePx = Math.max(12, Math.min(24, Math.round(stepWidth() * 0.05))); // 5% width, clamped
            const offset = direction === 'next' ? -wobblePx : wobblePx;

            const prevTransition = slider.style.transition;
            slider.style.transition = 'transform 150ms ease-out';
            slider.style.transform = `translateX(${posFor(index) + offset}px)`;
            setTimeout(() => {
                slider.style.transform = `translateX(${posFor(index)}px)`;
                setTimeout(() => {
                    slider.style.transition = prevTransition || defaultTransition;
                }, 160);
            }, 150);
        }

        /* dots */
        if (dotContainer) {
            dotContainer.innerHTML = '';
            for (let i = 0; i <= maxIndex; i++) {
                const b = document.createElement('button');
                b.className = 'slider-dot';
                b.setAttribute('aria-label', `Slide ${i + 1}`);
                b.onclick = () => goTo(i);
                dotContainer.appendChild(b);
                dots.push(b);
            }
            setDot();
        }

        /* arrows */
        prevBtn?.addEventListener('click', () => {
            if (index <= 0) {
                wobbleEnd('prev');
            } else {
                goTo(index - 1);
            }
        });
        nextBtn?.addEventListener('click', () => {
            if (index >= maxIndex) {
                wobbleEnd('next');
            } else {
                goTo(index + 1);
            }
        });

        /* auto-rotate: do not wobble at the end */
        function tryAutoNext() {
            if (index < maxIndex) {
                goTo(index + 1);
            }
            // At end: no wobble, just stop.
        }
        if (autoRotate && slides.length > 1) {
            autoId = setInterval(tryAutoNext, rotateMs);
            sectionEl.onmouseenter = () => { clearInterval(autoId); autoId = null; };
            sectionEl.onmouseleave = () => {
                if (!autoId) autoId = setInterval(tryAutoNext, rotateMs);
            };
        }

        /* drag-to-slide with multi-step + elastic bounds (no wobble on release) */
        let dragging = false, maybe = false, sx = 0, base = 0, cur = 0;
        slider.style.touchAction = 'pan-y';
        slider.style.cursor = 'grab';

        const maxX = () => posFor(0);          // usually 0
        const minX = () => posFor(maxIndex);   // negative

        slider.onpointerdown = e => {
            maybe = true;
            sx = e.clientX;
            base = posFor(index);
            cur = base;
            slider.style.transition = 'none'; // immediate follow
        };

        slider.onpointermove = e => {
            if (!maybe) return;
            const dx = e.clientX - sx;
            if (!dragging && Math.abs(dx) > DRAG_START_THRESHOLD) {
                dragging = true;
                slider.setPointerCapture(e.pointerId);
                slider.style.cursor = 'grabbing';
            }
            if (dragging) {
                e.preventDefault();
                let tentative = base + dx;

                // Elastic resistance beyond bounds
                if (tentative > maxX()) {
                    tentative = maxX() + (tentative - maxX()) * ELASTIC;
                } else if (tentative < minX()) {
                    tentative = minX() + (tentative - minX()) * ELASTIC;
                }

                cur = tentative;
                slider.style.transform = `translateX(${cur}px)`;
            }
        };

        ['pointerup','pointerleave','pointercancel'].forEach(evt =>
            slider.addEventListener(evt, e => {
                const dx = cur - base; // negative = trying to go "next"
                slider.style.transition = defaultTransition;

                if (dragging) {
                    slider.releasePointerCapture?.(e.pointerId);
                    slider.style.cursor = 'grab';

                    const w = stepWidth();

                    // If small nudge: snap back
                    if (Math.abs(dx) <= SLIDE_CHANGE_THRESHOLD) {
                        goTo(index);
                        dragging = maybe = false;
                        return;
                    }

                    // Multi-slide fling: compute intended steps by distance
                    const rawSteps = Math.round(-dx / w); // left drag -> positive steps
                    let target = index + rawSteps;

                    // Clamp to bounds — no wobble on drag end
                    if (target > maxIndex) {
                        goTo(maxIndex);
                    } else if (target < 0) {
                        goTo(0);
                    } else {
                        goTo(target);
                    }
                }

                dragging = maybe = false;
            })
        );

        /* start */
        goTo(0);
        sectionEl._lastSlidesToShow = slidesToShow;
    }

    /* ----- bootstrap all sliders ----- */
    function initAllSliders() {
        document.querySelectorAll('.product-slider-section').forEach(initProductSlider);
    }

    document.addEventListener('DOMContentLoaded', initAllSliders);
    document.addEventListener('shopify:section:load', initAllSliders);
    window.addEventListener('resize', initAllSliders);

    window.initAllSliders = initAllSliders;
})();
